export default __webpack_public_path__ + "static/media/1203.a412d89f.png";